export default "__VITE_ASSET__aab1c37f__"